/*
  Figma "Switch": 51×31, the accent when on, fill/primary when off, a white knob
  with a soft shadow.
*/
const Switch = ({ on, disabled = false, onClick, label, className = "" }) => (
  <button
    type="button"
    role="switch"
    aria-checked={Boolean(on)}
    aria-label={label}
    disabled={disabled}
    onClick={onClick}
    className={`relative h-[31px] w-[51px] shrink-0 rounded-full transition-colors outline-none focus-visible:shadow-[0_0_0_2px_var(--color-focus-ring)] disabled:opacity-50 ${
      on ? "bg-accent-default" : "bg-fill-primary"
    } ${className}`}
  >
    <span
      className={`absolute left-[2px] top-[2px] size-[27px] rounded-full bg-control-knob shadow-[0_3px_8px_rgba(0,0,0,0.15)] transition-transform ${
        on ? "translate-x-[20px]" : ""
      }`}
    />
  </button>
);

export default Switch;
